export default __webpack_public_path__ + "static/media/img-04.308d507c.jpg";